exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span._1PLEk{cursor:pointer;font-size:16px;margin:0 8px}._26Rw6{color:#fff;background-color:#ce072c;padding:5px 8px;font-weight:700;border-radius:8px}._1QeDu,._3XCZA{color:#fff;background-color:#ce072c;padding:3px 8px;height:20px;border-radius:8px;font-size:13.6px;font-size:.85rem}._1QeDu{font-weight:700}", ""]);

// exports
exports.locals = {
	"btn": "_1PLEk",
	"primaryTitle": "_26Rw6",
	"secondaryTitle": "_3XCZA",
	"grayTitle": "_1QeDu"
};